import {
  CommonActions,
  RouteProp,
  useFocusEffect,
  useNavigation,
  useRoute,
} from '@react-navigation/native'
import React, { useContext, useEffect, useState } from 'react'
import { LogisticsRoutes, RootParams } from '../../../../../navigator/types'
import { TakePhoto } from '../../../../../components/TakePhoto'
import { AlertMessage } from '../../../../../components/AlertMessage'
import { StackNavigationProp } from '@react-navigation/stack'
import { FuelContext } from '../../../../../context/Logistics/fuel/FuelProvider'
import { BodyAlert } from '../../components/BodyAlert'
import { InstructionsView } from './components/InstructionsView'

interface Navigation extends StackNavigationProp<LogisticsRoutes, 'VoucherPhoto'> {}

export const VoucherPhoto = () => {
  const { handleTakePhoto, handleSaveRecord, handleResetForm, form } = useContext(FuelContext)
  const navigation = useNavigation<Navigation>()
  const rootNavigation = useNavigation<StackNavigationProp<RootParams>>()
  const route = useRoute<RouteProp<LogisticsRoutes, 'VoucherPhoto'>>()
  const [show, setShow] = useState({
    alert: false,
    camera: true,
  })

  const [photo, setPhoto] = useState('')
  const [showPreview, setShowPreview] = useState(true)

  const handlePause = () => {
    handleSaveRecord({ ...form, stateForm: 'in-progress' })
    handleResetForm()
    rootNavigation.dispatch(CommonActions.reset({ index: 0, routes: [{ name: 'HomeScreen' }] }))
  }

  const handleNavigate = () => {
    handleTakePhoto({ type: 'voucherPhoto', uri: photo })
    navigation.navigate('VoucherLog')
    setShow({
      alert: false,
      camera: false,
    })
  }
  const handleSkipPhoto = () => {
    navigation.navigate(route.params?.returnToSummary ? 'VoucherLog' : 'Summary')
    setShow({
      alert: false,
      camera: false,
    })
  }

  useFocusEffect(
    React.useCallback(() => {
      setShow({
        alert: false,
        camera: true,
      })

      return () => {
        setShow({
          alert: false,
          camera: false,
        })
      }
    }, []),
  )

  useEffect(() => {
    if (route.params) {
      setShow({
        alert: !!route.params.uri,
        camera: !route.params.uri,
      })
      setPhoto(route.params.uri)
    }
  }, [route.params])

  if (showPreview) {
    return <InstructionsView continueAction={() => setShowPreview(false)} />
  }
  return (
    <>
      {show.camera && (
        <TakePhoto
          skipBtn={{
            show: !route.params?.returnToSummary,
            action: handleSkipPhoto,
          }}
          pauseBtn={{ show: true, action: handlePause }}
          getPhoto={(uri) => {
            setPhoto(uri)
            setShow({
              alert: true,
              camera: false,
            })
          }}
          capturingText='FOTO COMPROBANTE DE ENTREGA'
          indicationsText='Saque una foto del comprobante de entrega del proveedor'
        />
      )}

      {show.alert && (
        <AlertMessage
          title=''
          cancelLabel='Repetir foto'
          successLabel='Continuar'
          action={handleNavigate}
          cancelButton
          style={{ position: 'absolute' }}
          actionCancelButton={() => setShow({ alert: false, camera: true })}
        >
          <BodyAlert
            title='Foto tomada con éxito'
            onClose={() => setShow({ alert: false, camera: true })}
            uri={photo}
          />
        </AlertMessage>
      )}
    </>
  )
}
